export default "__VITE_ASSET__BSMxrzBq__"